module.exports = __webpack_public_path__ + "img/link_banner.bf82a91a.jpg";